<template>
  <div class="pop-up-container px-3 pt-3 pb-3">
    <div class="confirmationPopup">
      <div class="confirmationPopup__header">
        <p v-if="hasConfirmationText" class="confirmationPopup__title font-weight-semi-bold mb-1">
          {{ $t('general.components.confirmation-popup.title', [referenceText]) }}
        </p>
        <p v-else class="confirmationPopup__title font-weight-semi-bold mb-1">
          {{ $t('general.components.confirmation-popup.no-type.title') }}
        </p>
      </div>
      <div class="confirmationPopup__body">
        <p class="confirmationPopup__description text-gray-700">
          {{ popupDescriptionT }}
        </p>
        <CInput v-if="hasConfirmationText" class="confirmationPopup__input" type="text" v-model="textConfirm" />
      </div>
      <div class="confirmationPopup__footer">
        <div class="confirmationPopup__actions text-capitalize text-right">
          <CButton :disabled="isConfirmDisabled" class="confirmationPopup__btn btn btn-primary text-capitalize" @click="confirm">
            {{ $t('general.components.confirmation-popup.btn.confirm') }}
          </CButton>
          <CButton class="confirmationPopup__btn text-capitalize ml-3" @click="cancel" type="link">
            {{ $t('general.components.confirmation-popup.btn.cancel') }}
          </CButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationPopup',
  props: {
    hasConfirmationText: { type: Boolean, default: () => true },
    popupDescriptionT: { type: String },
    referenceText: {
      type: String,
    },
  },
  data() {
    return {
      textConfirm: '',
    }
  },
  computed: {
    isConfirmDisabled() {
      return this.hasConfirmationText && this.textConfirm !== this.referenceText
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
.confirmationPopup {
  max-width: 250px;
  &__title {
  }

  &__input {
    border: 1px solid #ccc;
  }

  &__description {
  }

  &__actions {
    text-transform: capitalize;
  }

  &__btn {
  }
}
.pop-up-container {
  margin-top: -40px;
  margin-left: 25px;
  width: max-content;
  position: relative;
  z-index: 1001;
  background-color: white;
  border: 1px solid $gray-200;
  box-shadow: 9px 14px 12px 0px rgba(211, 211, 211, 0.75);
  -webkit-box-shadow: 9px 14px 12px 0px rgba(211, 211, 211, 0.75);
  -moz-box-shadow: 9px 14px 12px 0px rgba(211, 211, 211, 0.75);
}
</style>
